import { get, post, post2 } from "../http/http.js"
import axios from "axios"
//封装接口的方法

export function login (data) {
    return post("/login", data)
}

export function dupcheck (data) {
    return post("/util/field/dupcheck", data)
}


export function getTenantUsers (data) {
    return post("/tenantusers", data)
}

export function getTenantUser (data) {
    return post("/tenantuser", data)
}

export function createTenantUser (data) {
    return post("/tenantuser/create", data)
}

export function updateTenantUser (data) {
    return post("/tenantuser/update", data)
}

export function dingLogin (data) {
    return post("/dingding_back", data)
}

// 飞书扫码登录，传参结构同 dingLogin：{mode:3, code, tenant, appid: 飞书AppID}
export function feishuLogin (data) {
    return post("/feishu_back", data)
}

export function getUserInfoApi (data) {
    return post("/tenantuser", data)
}

export function updatePassApi (data) {
    return post("/user/password/update", data)
}

export function updateUserInfoApi (data) {
    return post("/tenantuser/update", data)
}

export function updateAvatarApi (data, config) {
    return post2("/user/update_avatar", data, config)

}

/**
 * 获取
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getProjects (data) {
    return post2("/dao/v3/orderOld/project", data)
}

/**
 * 获取汇总数据列表
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getAccu (data) {
    return post2("/accu", data)
}


export function getSelection (data) {
    return post2("/dao/v3/orderOld/item", data)
}

/**
 * 列表导出excel
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function exportExcel (data) {
    return post2("/dao/v3/orderOld/op/projects", data, { responseType: 'blob' })
}

/**
 * 列表明细导出excel
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function exportExcelDetail (projectId, data) {
    return post2("/op/project/" + projectId, data, { responseType: 'blob' })
}
/**
 * 汇总列表导出excel
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function exportExcelAccu (data) {
    return post2("/op/accu", data, { responseType: 'blob' })
}

export function changeSelection (data) {
    return post2("/dao/v3/orderOld/item/op", data)
}

export function updateLasttime (data) {
    return post2("/dao/v3/orderOld/item/update/lasttime", data)
}

export function updateName (data) {
    return post2('/dao/v3/orderOld/item/update/name', data)
}

export function getProjectInfo (data) {
    return post2("/project/" + data.project_id, data)
}

export function submitIncome (data) {
    return post2("/progress/create", data)
}

export function getProjectALLInfo (data) {
    return post2("/progress/get_project", data)
}

export function status_change (data) {
    return post2("/progress/status_change", data)
}

export function remark (data) {//订单异常设置
    return post2("/progress/remark", data)
}

export function remarkList (data) {//异常备注列表
    return post2("/progress/remark_list", data)
}

export function orderDone (data) {//设置订单完结接口
    return post2("/progress/finish", data)
}



export function balanceWithdraw (data) {
    return post2("/v3/progress/balanceWithdraw", data)
}

export function balances (data) {
    return post2("/v3/progress/balances", data)
}

/**
 * 业绩表现
 */
export function getPerformance (data) {
    // console.log("getPerformance请求在此",data)
    return post2("/dao/v3/performance/index", data)
}

export function exportPerformanceDetail (data) {
    return post2("/dao/v3/performance/export", data, { responseType: 'blob' })
}

export function performancePermission (data) {
    return post2("/dao/permission", data)
}

export function getTodoList (data) {
    return post2("/dao/v3/todolist/index", data)
}

export function getTodoListCount (data) {
    return post2("/dao/v3/todolist/count", data)
}

export function exportTodoList (data) {
    return post2("/dao/v3/todolist/export", data, { responseType: 'blob' })
}

export function getPassRate (data) {
    return post("/dao/v3/todolist/passrate", data)
}

export function getPassRateTimeOption (data) {
    return post("/dao/v3/todolist/passrate_time_option", data)
}

export function getUnusualList (data) {
    return post2("/progress/unusual", data)
}

export function getFinancial (data) {
    return post2("/dao/v3/financial/info", data)
}

export function exportFinancial (data) {
    return post2("/dao/v3/financial/export", data, { responseType: 'blob' })
}

export function userDept (data) {
    return post("/dao/v3/todolist/user_dept", data)
}
export function getUsageRecord (data) {
    return post2("/dao/v3/tracking/usage_record", data)
}

export function exportUsageRecord (data) {
    return post2("/dao/v3/tracking/export", data, { responseType: 'blob' })
}

export function getPrePay (data) {
    return post2("/dao/v3/tracking/usage_record", data)
}

export function exportPrePay (data) {
    return post2("/dao/v3/tracking/export", data, { responseType: 'blob' })
}

export function getAdvance (data) {
    return post2("/dao/v3/financial/info", data)
}

export function exportAdvance (data) {
    return post2("/dao/v3/financial/export", data, { responseType: 'blob' })
}

export function getProjectByInvoiceId (data) {
    return post2("/dao/v3/financial/project", data)
}

export function exportProjectDetail (data) {
    return post2("/dao/v3/financial/project_export", data, { responseType: 'blob' })
}

export function getPrizeAccount (data) {
    return post2("/dao/v3/financial/prize_account", data)
}

export function getPermissionTest (data) {
    return post2("/dao/permission/test", data)
}

export function getClueOption (data) {
    return post("/dao/v3/clue/get_option_info", data)
}

export function addClue (data) {
    return post("/dao/v3/clue/add_clue", data)
}

export function addClient (data) {
    return post("/dao/v3/clue/add_client", data)
}

export function getclueInfo (data) {
    return post("/dao/v3/clue/clue_info", data)
}

export function editClueInfo (data) {
    return post("/dao/v3/clue/edit_clue_info", data)
}

export function addClueInfoContent (data) {
    return post("/dao/v3/clue/add_content", data)
}

export function getThisMonthClue (data) {
    return post("/dao/clue/this_month_clue", data)
}
export function getClueTrend (data) {
    return post("/dao/clue/clue_trend", data)
}

export function getClueList (data) {
    return post("/dao/v3/clue/clue_list", data)
}

export function exportClue (data) {
    return post2("/dao/v3/clue/export", data, { responseType: 'blob' })
}

export function getClueRankCensus (data) {
    return post("/dao/clue/rank_census", data)
}

export function getClueCensus (data) {
    return post("/dao/clue/clue_census", data)
}

export function getDeptCensus (data) {
    return post("/dao/clue/dept_census", data)
}

export function getPieChartCensus (data) {
    return post("/dao/clue/chart_census", data)
}

export function getClueChartCensus (data) {
    return post("/dao/clue/clue_chart_info", data)
}

export function getMessage (data) {
    return post("/dao/v3/message/index", data)
}

export function handleMessage (data) {
    return post("/dao/v3/message/handle", data)
}

export function handleMessageActiveFlow (data) {
    return post("/dao/v3/message/active_flow", data)
}
export function handleBalanceWithdraw (data) {
    return post("/dao/v3/financial/balance_withdraw", data)
}

export function getClientList (data) {
    return post("/dao/v3/client/client_list", data)
}

export function exportClient (data) {
    return post2("/dao/v3/client/client_list_export", data, { responseType: 'blob' })
}

export function getPerformanceOptions (data) {
    // 获取下拉筛选项
    return post("/dao/v3/performance/get_options", data)
}

/**
 * 根据客户名称请求客户基本信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getClientBaseInfo (data) {
    return post('/dao/client/client_baseinfo', data)
}

export function editClientInfo (data) {
    return post('/dao/client/edit_client_info', data)
}

/**
 * 根据客户的id请求客户的联系人信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getClientContact (data) {
    return post('/dao/client/client_contact', data)
}

/**
 *  获取客户总数，本月新增，本月获取，本月流失
 */
export function getClientCount (data) {
    return post('/dao/client/client_count', data)
}

/**
 * 获取客户首页图表信息（客户资产、业绩表现）
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getClientChart (data) {
    return post('/dao/client/client_chart', data)
}

/**
 * 获取客户联系人的表单
 * @param data
 * @returns {Promise<unknown>}
 */
export function getContactList (data) {
    return post("/dao/client/contact_list", data)
}

/**
 * 导出客户联系人为文件
 * @param data
 * @returns {Promise<unknown>}
 */
export function exportContact (data) {
    return post2("/dao/client/contact_list_export", data, { responseType: 'blob' })
}

/**
 *  获取客户偏好
 */
export function getClientPreference (data) {
    return post("/dao/client/client_preference", data)
}

/**
 *  添加客户偏好
 */
export function addClientPreference (data) {
    return post("/dao/client/add_client_preference", data)
}

/**
 *  获取客户资产
 */
export function getClientAssets (data) {
    return post("/dao/client/client_assets", data)
}

/**
 *  获取客户业绩表现
 */
export function getClientPerformance (data) {
    return post("/dao/client/client_performance", data)
}

/**
 *  添加客户联系人
 */
export function addClientContact (data) {
    return post("/dao/client/add_client_contact", data)
}

/**
 *  获取客户联系人详细信息
 */
export function getContactBaseinfo (data) {
    return post("/dao/client/contact_baseinfo", data)
}

/**
 *  修改客户联系人信息
 */
export function editContactBaseinfo (data) {
    return post("/dao/client/edit_client_contact", data)
}

/**
 *  获取客户联系人偏好
 */
export function getContactPreference (data) {
    return post("/dao/client/contact_preference", data)
}

/**
 *  添加客户联系人偏好
 */
export function addContactPreference (data) {
    return post("/dao/client/add_contact_preference", data)
}

/**
 *  获取客户商机列表
 */
export function getClientClueList (data) {
    return post("/dao/client/get_clue_list", data)
}
/**
 *  导出客户商机列表
 */
export function exportClientClueList (data) {
    return post2("/dao/client/clue_list_export", data, { responseType: 'blob' })
}

/**
 *  获取客户合同列表
 */
export function getClientContractList (data) {
    return post("/dao/client/get_contract_list", data)
}

/**
 *  导出客户合同列表
 */
export function exportClientContractList (data) {
    return post("/dao/client/contract_list_export", data, { responseType: 'blob' })
}

/**
 *  获取客户订单列表
 */
export function getClientProjectList (data) {
    return post("/dao/client/get_project_list", data)
}

/**
 *  导出客户订单列表
 */
export function exportClientProjectList (data) {
    return post("/dao/client/project_list_export", data, { responseType: 'blob' })
}

/**
 *  获取客户结算列表
 */
export function getClientSettlementList (data) {
    return post("/dao/client/get_settlement_list", data)
}

/**
 * 导出客户结算列表
 */
export function exportClientSettlementList (data) {
    return post("/dao/client/settlement_list_export", data, { responseType: 'blob' })
}

export function exportPassrateDetail (data) {
    return post2("/dao/v3/todolist/export_passrate_detail", data, { responseType: 'blob' })
}

export function getEstimatedAdvance (data) {
    return post2("/dao/project/getEstimatedAdvance", data,)
}

export function createEstimatedAdvance (data) {
    return post2("/dao/project/createEstimatedAdvance", data,)
}

export function getItemInfo(data) {
    return post2("/dao/item/info", data)
}

export function exportItem (data) {
    return post2("/dao/item/export", data, { responseType: 'blob' })
}

export function getAchievementsInfo(data) {
    return post2("/dao/v3/achievements/info", data)
}

export function exportAchievements (data) {
    return post2("/dao/v3/achievements/export", data, { responseType: 'blob' })
}

export function getPurchaseInfo(data) {
    return post2("/dao/purchase/info", data)
}

export function exportPurchase (data) {
    return post2("/dao/purchase/export", data, { responseType: 'blob' })
}

// 获取业绩表现 盈亏平衡 系数
export function getProfitLossLine(data) {
    return post2("/dao/v3/performance/get_profit_loss_line", data)
}

// 查看商机售前介入任务
export function getPreSaleTaskList(data) {
    return post2("/dao/v3/clue/get_presale_task_list", data)
}
// 新增售前介入任务
export function createPreSaleTask(data) {
    return post2("/dao/v3/clue/create_zentao_presale_task", data)
}
// 新增售前介入任务 可选项
export function getPreSaleOptionInfo(data) {
    return post2("/dao/v3/clue/get_option_info", data)
}